"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrategistAllocationStatusList = void 0;
exports.StrategistAllocationStatusList = [
    {
        label: 'Onboarding',
        value: 'onboarding',
    },
    {
        label: 'Available for In-Region Allocations Only',
        value: 'available for in-region allocations only',
    },
    {
        label: 'Available for Sister-Region Allocations Only',
        value: 'available for sister-Region allocations only',
    },
    {
        label: 'Available for In-Region & Sister-Region Allocations',
        value: 'available for in-region & sister-region allocations',
    },
    {
        label: 'Available for In-Region, Sister-Region & Out-of-Region Allocations',
        value: 'available for in-region, sister-region & out-of-region allocations',
    },
    {
        label: 'Not Available for Allocation',
        value: 'unavailable',
    },
    {
        label: 'Offboarding',
        value: 'offboarding',
    },
    {
        label: 'Resigned',
        value: 'resigned',
    },
];
//# sourceMappingURL=strategistAllocationStatus.js.map